import doNotTrack from "util/doNotTrack";
import { isIE } from "react-device-detect";
export default () => {
    if (!doNotTrack() && !isIE) {
        const mouseflow = document.createElement("script");
        mouseflow.type = "text/javascript";
        mouseflow.async = true;
        mouseflow.src = "//cdn.mouseflow.com/projects/9daadec9-1e06-4299-8e4e-ce2065ed979c.js";
        document.getElementsByTagName("head")[0].appendChild(mouseflow);
    }
};
